export const RAW_SEARCH_SIZE = 10

export const DELAY = 500

export const DEFAULT_PAGE_SIZE = 10

export const INITIAL_PAGE_SIZE = 30

export const DEFAULT_BIG_PAGE_SIZE = 999_999

export const ORANGE_COLOR = '#ea4a1b'

export const BLUE_COLOR = '#3bb0d0'

export const DEFAULT_NAME_WITH_TOOLTIP_LENGTH = 20

export const DEFAULT_LOADER_SIZE = 30

export const SCROLL_THRESHHOLD = 1000

export const TABLE_EMPTY_TEXT = 'Ничего не найдено'
